var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplicitTemperatureSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#20E290"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8105 7.19526C16.0632 7.45561 16.0632 7.87772 15.8105 8.13808L9.33989 14.8047C9.08722 15.0651 8.67751 15.0651 8.42482 14.8047L5.18952 11.4714C4.93683 11.2111 4.93683 10.7889 5.18952 10.5286C5.44221 10.2683 5.85191 10.2683 6.1046 10.5286L8.88236 13.3905L14.8954 7.19526C15.1481 6.93491 15.5578 6.93491 15.8105 7.19526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplicitTemperatureSuccess);
export default __webpack_public_path__ + "static/media/implicit_temperature_success.02e797a29ba99353b36a149df41a3815.svg";
export { ForwardRef as ReactComponent };